import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';


import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import ShipmentsFilter from '../../components/inventory/Shipments/ShipmentsFilter';
import ShipmentsMode from '../../components/inventory/Shipments/ShipmentsMode';
import ShipmentsList from '../../components/inventory/Shipments/ShipmentsList';


import { useSessionContext } from '../../contexts/SessionContext';

export default function InventoryShipmentsPage( props ) {
    //console.debug("RTS Break InventoryShipmentsPage");

    const {user, userAuthToken, apiRoot} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);
    const [mode, setMode] = useState(-2);
    const [data, setData] = useState([]);
    const [hasError, setHasError] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");

    const [shipmentsFilters] = useState({});
    
    const [filter, setFilter] = useState(
        {
            "user":user,
            "customer":null,
            "shipDate":null, 
            "product":null, 
            "reelType":null,
            "salesOrder":null,
            "customerPO":null,
            "deliveryNumber":null,
            "reelSerialNumber":null,
            "returnDate":null,
            "status":1 
        }
    );


    const fetchData = useCallback(() => {
        let apiURL = apiRoot + "/Inventory/GetShipmentsList";
        axios
        .post(
            apiURL,
            filter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
                if(response.data.length === 0)
                {
                    setMode(-1);
                }
                setIsLoading(false);
                setHasError(false);
            }
            else{
                setMode(-1);
            }
        })
        .catch(error => {
            setIsLoading(false);
            setHasError(true);
            console.log("RTS Data Error", error);
        });
    },[apiRoot, userAuthToken.token, filter]);


    useEffect(() => {
        if(mode > -2){
            fetchData();
        }
    }, [props, mode, filter, fetchData]);

    
    useEffect(() => {
        props.setIsModalFx(false);
        setIsLoading(false);
        setHasError(false);
    },[props]);


    function dataFilter(args){
        if(args.customer == null && args.product == null && args.reelType == null){
                setErrorTitle("Input Required");
                setErrorBody("A Customer, Product, or Reel Type must be selected in order to continue");
                setShowErrorModal(true);
                return;            
        }

        setIsLoading(true);
        let locFilter = {"user": user,
                        "customer": args.customer,
                        "shipDate": args.shipDate,
                        "product": args.product,
                        "reelType": args.reelType, 
                        "salesOrder": args.salesOrder,
                        "customerPO": args.customerPO,
                        "deliveryNumber": args.deliveryNumber,
                        "reelSerialNumber": args.reelSerialNumber,
                        "returnDate": args.returnDate,
                        "status": args.status 
                    }

        setFilter(locFilter);
        setMode(0);
    }


    function openBaseMode(args){
        setIsLoading(true);
        //setBaseMode(args);
        setMode(args);
        setIsLoading(false);
    }


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>         
        <Box id="pageBox">
            <Box id="filterBox">
                <ShipmentsFilter filter={filter} setFilterFx={dataFilter} shipmentsFilters={shipmentsFilters} />            
            </Box>
            <Box id="modeBox">
                <ShipmentsMode data={data} modeFx={openBaseMode} mode={mode} reelCount={data===null?0:data.length} />            
            </Box>            
            <Box id="contentBox">
                {mode===-2?<Box sx={{textAlign:"center", pt:2}}><Typography variant='h5'>Select the needed filters and click the Find button</Typography></Box>:""}
                {mode===-1?<Box sx={{textAlign:"center", pt:2}}><Typography variant='h5'>No Data Found</Typography></Box>:""}
                {mode===0?<ShipmentsList data={data} user={user} />:""}
            </Box> 
        </Box>
        </>
    );
}

